
import { useState, useCallback } from "react";
import { useChatLogic } from "./chat/useChatLogic";

export function useChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  
  const {
    inputValue,
    setInputValue,
    isLoading,
    messages,
    handleSendMessage,
    handleKeyDown,
    clearMessages,
    scrollAreaRef,
    waitingMessages,
    isShowingWaitingMessages,
    waitingMessageCategory
  } = useChatLogic();

  const toggleWidget = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    // Widget state
    isOpen,
    toggleWidget,
    handleClose,
    
    // Chat functionality
    inputValue,
    setInputValue,
    isLoading,
    messages,
    handleSendMessage,
    handleKeyDown,
    clearMessages,
    scrollAreaRef,
    
    // Waiting messages
    waitingMessages,
    isShowingWaitingMessages,
    waitingMessageCategory
  };
}
